import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data/data.service';

@Component({
    selector: 'app-cart-footer',
    template: `
    <div class="w-100 d-flex align-items-center justify-content-center py-1">
      <button class="btn btn-success btn-lg d-flex align-items-center p-0 w-75 text-white"
              [appLoadingOverlay]="paymentInProgress"
              (click)="makePayment()"
              *ngIf="dataService.hasEntryInCart">
        <span class="rounded-start py-2 count-button px-1 flex-grow-0">
          {{dataService.orderedItemsCount}}
        </span>
        <span class="rounded-start ps-1 pe-2 flex-grow-1">
          <span class="d-flex align-items-center justify-content-between">
            <span i18n class="text-uppercase fs-5 ms-2 me-5">Summe</span>
            <span class="fs-5">{{dataService.cart.totalPrice | currency}}</span>
          </span>
        </span>
      </button>

      <button *ngIf="!dataService.hasEntryInCart" class="btn btn-lg btn-secondary w-75 py-2" disabled i18n>
        Der Warenkorb ist leer.
      </button>
    </div>
  `,
    styles: [`
    :host {
      display: block;
    }

    .count-button {
      background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
      flex-basis: 64px;
    }
  `],
    standalone: false
})
export class CartFooterComponent {
  paymentInProgress = false;

  constructor(public dataService: DataService,
    private readonly router: Router) {
  }

  async makePayment() {
    this.router.navigate(['/payment']);
  }
}
